// extracted by mini-css-extract-plugin
module.exports = {"container":"Processed_container__2JtQa"};